const { decryptResponse, encryptResponse } = require("../components/encryptResp");

const apiKey = process.env.REACT_APP_API_KEY

// Standardize response handling for all API calls
const handleApiResponse = async (response) => {
    try {
        const data = await response.json();
        return decryptResponse(data.encrypted, data.iv);
    } catch (error) {
        console.error('API Response Error:', error);
        return { status: false, message: "Internet Server Error" };
    }
};

// Admin
const AdminAuthCheck = async (body) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch('/api/admin/auth/check', {
            method: "GET",
            headers: {
                'x-api-key': apiKey,
                'Authorization': `Bearer ${token}`
            },
        })
        return handleApiResponse(resp)
    } catch (error) {
        console.error("Admin Auth Check" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const AdminLogin = async (body) => {
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch('/api/admin/login', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        })
        return handleApiResponse(resp)
    } catch (error) {
        console.error("Admin Login" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Admin Views Dashbord and Click Dashbord
const adminViewsDashbord = async (id, startDate, endDate) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/admin/view/dashbord/${id}?startDate=${startDate}&endDate=${endDate}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Brand Story
const setStoryBrand = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/sortcut`, {
            method: "POST",
            headers: {
                'x-api-key': apiKey,
                'Authorization': `Bearer ${token}`
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getAllStoryBrand = async (page, limit, q) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/sortcut?page=${page}&limit=${limit}&q=${q}&a=true`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const uploadStoryBrand = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/sortcut`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const editStoryBrand = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/sortcut`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteStoryBrand = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/sortcut`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// InHOUSE Ads

const uploadInHouseAds = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/inhouse/ads`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getInHouseAds = async (page, limit, q) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/inhouse/ads?a=true&page=${page}&limit=${limit}&q=${q}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const setInHouseAdsStatus = async (id, status) => {
    const token = localStorage.getItem('admin_download');
    try {
        const body = {
            id,
            status
        }
        const resp = await fetch(`/api/App/inhouse/ads/update/status`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': apiKey
            },
            body: JSON.stringify(body),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteInhouseAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/inhouse/ads`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const getInHouseAdsData = async (id) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/inhouse/ads/data/${id}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateInHouseAds = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/inhouse/ads`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Native Ads
const getNativeAds = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/ads/native/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateNativeAds = async (id, body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/native/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}


const addNativeAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/native/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Full Screen Ads
const getFullScreenAds = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/ads/fullScreen/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateFullScreenAds = async (id, body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/fullScreen/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addFullScreenAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/fullScreen/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Banner Ads
const getBannerAds = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/ads/banner/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateBannerAds = async (id, body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/banner/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addBannerAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/banner/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Open Ads
const getOpenAds = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/ads/open/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addOpenAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/open/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateOpenAds = async (id, body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/open/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Reward Ads
const getRewardAds = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/ads/reward/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addRewardAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/reward/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateRewardAds = async (id, body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/reward/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getWebAds = async (startDate, endDate) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/ads/webads/admin/get?startDate=${startDate}&endDate=${endDate}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addWebAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/webads/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateWebAds = async (id, body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/webads/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteWeb = async (id) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/ads/webads/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
                'Content-Type': 'application/json'
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteWebClear = async (id, startDate, endDate) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/ads/webads/count/remove/${id}?startDate=${startDate}&endDate=${endDate}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
                'Content-Type': 'application/json'
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const alldeleteWebClear = async (body, startDate, endDate) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/ads/webads/count/all/remove?startDate=${startDate}&endDate=${endDate}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Ads Tracker
const adminAdsTrackDashbord = async (startDate, endDate, type = 'all') => {
    const token = localStorage.getItem('admin_download');
    try {

        const resp = await fetch(`/api/app/ads/track/analytic/admin?startDate=${startDate}&endDate=${endDate}&type=${type}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const adminAdsTrackDelete = async (startDate, endDate, type = 'all') => {
    const token = localStorage.getItem('admin_download');
    try {

        const resp = await fetch(`/api/app/ads/track/analytic/admin?startDate=${startDate}&endDate=${endDate}&type=${type}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Controller
const getControleData = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/admin/ControlerData`, {
            method: "GET",
            headers: {
                'Authorization': `Barear ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getMaintenance = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/Controler/maintenance/status`, {
            method: "GET",
            headers: {
                'Authorization': `Barear ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const setControleStoryVideo = async (name, status) => {
    const token = localStorage.getItem('admin_download');
    try {
        const body = {
            name,
            status
        }
        const resp = await fetch(`/api/App/Controler/Edit/storyVideo`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': apiKey
            },
            body: JSON.stringify(body),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const setControleStoryPostion = async (name, value,) => {
    const token = localStorage.getItem('admin_download');
    const body = {
        name,
        value,
    }
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/Controler/Edit/storyAdsPosition`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const setControlePayAmount = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/Controler/Edit/payAmount`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const setControlePhonePay = async (body) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/Controler/Edit/phone/pay`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': apiKey
            },
            body: JSON.stringify(body),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const setControllerSetAfterSplace = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {

        const resp = await fetch(`/api/App/controler/admin/afterIntro/change`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error)
        return { status: false, message: "Internet Server Error" };
    }
}

const installNew = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/controler/install/new`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Web Url Set
const setControleWebUrl = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/Controler/Edit/weburl`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Facebook
const setControleFacebook = async (body) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/Controler/Edit/facebook/data`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': apiKey
            },
            body: JSON.stringify(body),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Reels 
const addReels = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/reels`, {
            method: "POST",
            headers: {
                'x-api-key': apiKey,
                'Authorization': `Bearer ${token}`
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteReels = async (body) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/reels`, {
            method: "DELETE",
            headers: {
                'x-api-key': apiKey,
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getReels = async (page, limit) => {
    try {
        const resp = await fetch(`/api/App/reels?page=${page}&limit=${limit}&a=true`, {
            method: "GET",
            headers: {
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Policy 
const getPolicy = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/policy/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },

        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const updatePolicy = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/policy/admin/update`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

// LiveMatch
const getAllLiveMatch = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/liveMatch/admin`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const editLiveMatch = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/liveMatch/admin`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteLiveMatch = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/liveMatch/admin`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const uploadLiveMatch = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/liveMatch/admin`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const editLiveMatchStatus = async (id) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/liveMatch/admin/status/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Server Load Checker
const getServerLoadCheck = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/Controler/app/loadCheck`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}


// Notification 
const getNotificationHistory = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/notification/history`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });

        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteNotification = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/notification/delete`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const sendNotification = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/notification/send`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const ResendNotification = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/notification/resend`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// LiveMatch Ad
const getAllLiveMatchAd = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/liveMatch/liveAds`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const editLiveMatchAd = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/liveMatch/liveAds`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json",
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// LiveMatch Ad Web
const getAllLiveMatchAdWeb = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/liveMatch/liveAdsWeb`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addLiveMatchAdWeb = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/liveMatch/liveAdsWeb`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json",
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const editLiveMatchAdWeb = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/liveMatch/liveAdsWeb`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json",
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteLiveMatchAdWeb = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/LiveMatch/liveAdsWeb`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}


// Fire Ads
const fireLiveMatchAdWeb = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/LiveMatch/admin/ads/fire`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json",
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Fire Ads History
const fireLiveMatchAdWebHistory = async (page, limit) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/LiveMatch/admin/ads/fire/history?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json",
                'x-api-key': apiKey
            }
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const fireLiveMatchAdWebHistoryDelete = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/LiveMatch/admin/ads/fire/history`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "application/json",
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Story Video
const addStoryVideo = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/Add/Story/Video`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getStories = async (page, limit) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/all/only/story/video?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getStoriesAds = async (page, limit) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/all/only/story/ads?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteStoryVideo = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/delete/story/video`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteStoryAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/delete/story/ads`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateStoryData = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/Edit/story/video`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: formData
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getStoryData = async (id) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/story/video/find?id=${id}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getStoryAds = async (id) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/story/ads/find?id=${id}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const changeStoryVideoStatus = async (_id, status) => {
    const token = localStorage.getItem('admin_download');

    try {
        const body = {
            _id,
            status,
        }
        const resp = await fetch(`/api/App/story/video/status`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': apiKey
            },
            body: JSON.stringify(body),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const changeStoryAdsStatus = async (_id, status) => {
    const token = localStorage.getItem('admin_download');

    try {
        const body = {
            _id,
            status,
        }
        const resp = await fetch(`/api/App/story/ads/status`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Corrected 'Bearer'
                'x-api-key': apiKey
            },
            body: JSON.stringify(body),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Category
const insertCategory = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/video/category`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch {
        return { status: false, message: "Internet Server Error" };
    }
};

const updateCategoryStatus = async (id) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/video/category/status/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch {
        return { status: false, message: "Internet Server Error" };
    }
};

const updateCategory = async (formData) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/video/category`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: formData,
        });
        return handleApiResponse(resp);
    } catch {
        return { status: false, message: "Internet Server Error" };
    }
};

const deleteCategory = async (id) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/video/category/${id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch {
        return { status: false, message: "Internet Server Error" };
    }
};

const getAllCategories = async () => {
    const token = localStorage.getItem('admin_download');

    try {
        const resp = await fetch(`/api/App/video/category`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch {
        return { status: false, message: "Internet Server Error" };
    }
};

// Add Video
const addVideo = async (formData, onProgressUpdate) => {
    const token = localStorage.getItem('admin_download');

    try {
        // If we have a progress callback, use XMLHttpRequest for tracking
        if (onProgressUpdate) {
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();

                // Track upload progress
                xhr.upload.onprogress = (event) => {
                    if (event.lengthComputable) {
                        const percentComplete = Math.round((event.loaded / event.total) * 100);
                        onProgressUpdate({
                            loaded: event.loaded,
                            total: event.total,
                            percent: percentComplete
                        });
                    }
                };

                // Handle completion
                xhr.onload = () => {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            const response = JSON.parse(xhr.responseText);

                            // Handle encrypted response using the existing decryption method
                            if (response && response.encrypted && response.iv) {
                                // Use the existing decryptResponse function
                                const decryptedResponse = decryptResponse(response.encrypted, response.iv);
                                resolve(decryptedResponse);
                            } else {
                                // For non-encrypted responses
                                resolve(response);
                            }
                        } catch (error) {
                            console.error('Error parsing response:', error);
                            resolve({ status: false, message: 'Error parsing server response' });
                        }
                    } else {
                        reject(new Error(`HTTP Error: ${xhr.status}`));
                    }
                };

                // Handle errors
                xhr.onerror = () => {
                    reject(new Error('Network Error'));
                };

                // Open and send the request
                xhr.open('POST', '/api/App/video', true);
                xhr.setRequestHeader('Authorization', `Bearer ${token}`);
                xhr.setRequestHeader('x-api-key', apiKey);
                xhr.send(formData);
            });
        } else {
            // Use standard fetch if no progress tracking is needed
            const resp = await fetch(`/api/App/video`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'x-api-key': apiKey
                },
                body: formData,
            });

            // Handle the encrypted response using your existing function
            return handleApiResponse(resp);
        }
    } catch (error) {
        console.error('Upload error:', error);
        return { status: false, message: "Internet Server Error" };
    }
};

const getVideo = async (page, limit, category, web) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/video/category/admin/${category || 'all'}?page=${page}&limit=${limit}&web=${web}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteVideo = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);

    try {
        const resp = await fetch(`/api/App/video/`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),

        });
        return handleApiResponse(resp);
    } catch {
        return { status: false, message: "Internet Server Error" };
    }
};

const setVideoStatus = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/App/video/web/status`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}


// Client
const getVideoClient = async (page, limit) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/App/video/category/client?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}


// Ios
const getIosNativeAds = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/ios/ads/native/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosNativeAds = async (id, body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/native/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosNativeAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/native/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Full Screen Ads
const getIosFullScreenAds = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/ios/ads/fullScreen/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosFullScreenAds = async (id, body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/fullScreen/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosFullScreenAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/fullScreen/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Banner Ads
const getIosBannerAds = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/ios/ads/banner/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosBannerAds = async (id, body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/banner/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosBannerAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/banner/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Open Ads
const getIosOpenAds = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/ios/ads/open/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosOpenAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/open/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosOpenAds = async (id, body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/open/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Reward Ads
const getIosRewardAds = async () => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/ios/ads/reward/admin/get`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosRewardAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/reward/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosRewardAds = async (id, body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/reward/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Web Site
const getIosWebAds = async (startDate, endDate) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/ios/ads/webads/admin/get?startDate=${startDate}&endDate=${endDate}`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const addIosWebAds = async (body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/webads/add`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const updateIosWebAds = async (id, body) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/webads/update/${id}`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteIosWeb = async (id) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/ios/ads/webads/delete/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
                'Content-Type': 'application/json'
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const deleteIosWebClear = async (id, startDate, endDate) => {
    const token = localStorage.getItem('admin_download');
    try {
        const resp = await fetch(`/api/ios/ads/webads/count/remove/${id}?startDate=${startDate}&endDate=${endDate}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
                'Content-Type': 'application/json'
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

const allIosdeleteWebClear = async (body, startDate, endDate) => {
    const token = localStorage.getItem('admin_download');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/ios/ads/webads/count/all/remove?startDate=${startDate}&endDate=${endDate}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        console.log(error);
        return { status: false, message: "Internet Server Error" };
    }
}

module.exports = {
    AdminLogin,
    AdminAuthCheck,
    deleteStoryBrand,
    editStoryBrand,
    uploadStoryBrand,
    getAllStoryBrand,
    setStoryBrand,
    adminViewsDashbord,
    updateInHouseAds,
    getInHouseAdsData,
    deleteInhouseAds,
    setInHouseAdsStatus,
    getInHouseAds,
    uploadInHouseAds,
    getNativeAds,
    updateNativeAds,
    addNativeAds,
    getFullScreenAds,
    addFullScreenAds,
    updateFullScreenAds,
    addBannerAds,
    updateBannerAds,
    getBannerAds,
    getOpenAds,
    addOpenAds,
    updateOpenAds,
    getRewardAds,
    addRewardAds,
    updateRewardAds,
    setControlePhonePay,
    setControleFacebook,
    setControleWebUrl,
    getControleData,
    getMaintenance,
    setControleStoryVideo,
    setControleStoryPostion,
    setControlePayAmount,
    installNew,
    addReels,
    getReels,
    deleteReels,
    getPolicy,
    updatePolicy,
    getAllLiveMatch,
    editLiveMatch,
    deleteLiveMatch,
    uploadLiveMatch,
    editLiveMatchAd,
    getAllLiveMatchAd,
    getServerLoadCheck,
    sendNotification,
    deleteNotification,
    getNotificationHistory,
    ResendNotification,
    getAllLiveMatchAdWeb,
    editLiveMatchAdWeb,
    addLiveMatchAdWeb,
    fireLiveMatchAdWeb,
    fireLiveMatchAdWebHistory,
    fireLiveMatchAdWebHistoryDelete,
    deleteLiveMatchAdWeb,
    editLiveMatchStatus,
    setControllerSetAfterSplace,
    getWebAds,
    addWebAds,
    updateWebAds,
    deleteWeb,
    deleteWebClear,
    alldeleteWebClear,
    addStoryVideo,
    getStories,
    getStoriesAds,
    deleteStoryAds,
    deleteStoryVideo,
    updateStoryData,
    getStoryData,
    getStoryAds,
    changeStoryVideoStatus,
    changeStoryAdsStatus,
    getAllCategories,
    deleteCategory,
    updateCategory,
    insertCategory,
    addVideo,
    getVideo,
    deleteVideo,
    getVideoClient,
    setVideoStatus,
    getIosNativeAds,
    updateIosNativeAds,
    addIosNativeAds,
    adminAdsTrackDashbord, adminAdsTrackDelete,
    getIosFullScreenAds, updateIosFullScreenAds, addIosFullScreenAds, getIosBannerAds, updateIosBannerAds, addIosBannerAds, getIosOpenAds, addIosOpenAds, updateIosOpenAds, getIosRewardAds, addIosRewardAds, updateIosRewardAds, getIosWebAds, addIosWebAds, updateIosWebAds, deleteIosWeb, deleteIosWebClear, allIosdeleteWebClear,
    updateCategoryStatus
}